<div class="subBlockContainer" id="budgetAlertsDetail">
  <div class="subBlockContent">
    <child-header [title]="budget?.name" (closeEvent)="close()"></child-header>
    <div class="child-body">
      <div class="inner-subBlock-wrapper">
        <div class="col-md-12">

          <!-- header buttons -->
          <ng-container>
            <button
              [disabled]="!budget"
              class="button button-red button-round"
              (click)="editBudget()"
            >
              &nbsp;Edit&nbsp;
            </button>
          </ng-container>

          <!-- Budget Summary -->
          <ng-container>
            <div class="my-4">
              <h6>BUDGET SUMMARY</h6>
              <div class="my-4" *ngIf="budget">
  
                <div class="my-2">
                  Name : 
                  <span>
                    {{ budget?.name }}
                  </span>
                </div>

                <div class="my-2">
                  Amount :
                  <span>
                    {{ budget?.properties?.amount }}
                  </span>
                </div>
  
                <div class="my-2">
                  Period :
                  <span>
                    Resets {{ budget?.properties?.timeGrain | lowercase }}
                  </span>
                </div>
  
                <div class="my-2">
                  Creation date :
                  <span>
                    {{ budget?.properties?.timePeriod?.startDate | date:'dd/MM/yyyy' }}
                  </span>
                </div>

                <div class="my-2">
                  Expiration  date :
                  <span>
                    {{ budget?.properties?.timePeriod?.endDate | date:'dd/MM/yyyy' }}
                  </span>
                </div>
  
              </div>
              <mat-spinner
                *ngIf="!budget"
                mode="indeterminate"
                class="circle"
                diameter="20">
              </mat-spinner>
            </div>
          </ng-container>

          <!-- Budget Alerts -->
          <ng-container>
            <div class="my-4">
              <h6>BUDGET ALERTS</h6>
              <div class="my-4" *ngIf="budget">
  
                <div class="my-2">
                  <span class="highlight-text"> 
                    Alert conditions : 
                  </span>
                  <table mat-table style="width: 50%" [dataSource]="budgetDetailDataSrc" *ngIf="budgetDetailDataSrc?.length">
    
                    <ng-container matColumnDef="type">
                      <th mat-header-cell *matHeaderCellDef width="33%">Type</th>
                      <td mat-cell *matCellDef="let element"> {{ element.type }}  </td>
                    </ng-container>
    
                    <ng-container matColumnDef="percent">
                      <th mat-header-cell *matHeaderCellDef width="33%" style="text-align: center !important">% of budget</th>
                      <td mat-cell *matCellDef="let element" class="align-center"> {{ element.percent }} </td>
                    </ng-container>
    
                    <ng-container matColumnDef="amount">
                      <th mat-header-cell *matHeaderCellDef width="33%" style="text-align: center !important">Amount</th>
                      <td mat-cell *matCellDef="let element" class="align-center"> {{ element.amount | currency:'AUD':'symbol-narrow':'.2-2' }} </td>
                    </ng-container>
    
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>
                </div>

                <div class="my-2">
                  <span class="highlight-text"> 
                    Alert recipients (email) :
                  </span>
                  <div>
                    <ng-container *ngFor="let email of this.budget.properties.notifications.criticalAlert?.contactEmails">
                      <span >
                        {{ email }}
                      </span>
                      <br>
                    </ng-container>
                  </div>

                </div>
              </div>
              <mat-spinner
                *ngIf="!budget"
                mode="indeterminate"
                class="circle"
                diameter="20">
              </mat-spinner>
            </div>
          </ng-container>

        </div>
      </div>
    </div>
  </div>
  <router-outlet></router-outlet>

</div>
